// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fxt-favorite-heart[data-v-5a0bc7df]{position:absolute;top:-7px;right:-7px}.fxt-favorite-heart__bg-icon[data-v-5a0bc7df]{position:absolute;right:-2px;top:-2px}", ""]);
// Exports
module.exports = exports;
